<ion-img *ngFor="let banner of bannersVeiculacao; let i = index" (click)="touchGoToRoute(banner.link)"
  [src]="modelLocator.configUso._media + 'banners/' +  banner.imagem"></ion-img>